module.exports = __webpack_public_path__ + "static/img/cooperation.2016997.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/cooperation.png
// module id = fT1T
// module chunks = 0